<template>
  <nav v-if="$vuetify.breakpoint.mdAndUp" class="position-sticky">
    <v-toolbar :class="['elevation-1 d-flex flex-row justify-space-between background', $vuetify.breakpoint.lgAndUp ? 'mx-auto block-layout px-10' : 'text-no-wrap overflow-x-only ']">
      <CategoryBarItem v-for="category in categories" :key="category.name" :link="category.link" :name="category.name" :subcategories="category.subcategories" />
    </v-toolbar>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CategoryBarItem from '@/components/navbars/CategoryBarItem.vue'
export default {
  components: { CategoryBarItem },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('page', ['categories'])
  }
}
</script>

<style lang="scss" scoped>
.position-sticky {
  position: sticky;
  top: 0;
  z-index: 6;
}

/* .position-sticky-mobile {
  top: 56px;
} */

/* .height-auto {
  height: auto !important;
  ::v-deep .v-toolbar__content {
    height: auto !important;
  }
} */

/* ::v-deep .toolbar-center > .v-toolbar__content {
  justify-content: center;
  flex-wrap: wrap;
} */

.overflow-x-only {
  overflow-y: hidden;
  overflow-x: auto;
}

/* .unset-height {
  height: auto !important;

  ::v-deep .v-toolbar__content {
    height: auto !important;
    flex-wrap: wrap;
    justify-content: center;
  }
} */

/* ::v-deep .table-layout .v-toolbar__content {
  width: 100%;

  // table layout
  // display: table;
  // table-layout: fixed;
  
  //grid layout
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1px, 1fr));

  > .category {
    //display: table-cell;
    display: inline-flex;

    > .v-btn__content {
      white-space: normal;
      text-align: center;

      width: 100%;
      margin-top: auto;
      margin-bottom: auto;
    }
  }
} */

::v-deep .block-layout .v-toolbar__content {
  width: 100%;
}
</style>
